import { Component, OnInit } from '@angular/core';
import { WorkLogService } from '../../../services/work-log.service';
import { AuthenticationService } from '@kaiser-software/chassis-core';

@Component({
    selector: 'app-work-logs-index',
    templateUrl: 'index.component.html',
    styleUrls: ['index.component.scss']
})
export class WorkLogsIndexComponent implements OnInit {

    protected title = 'Work logs';

    protected routePrefix = 'work-logs';

    protected pluginPrefix = 'eyewatch-work-logs';

    public table = {};

    public user;

    public toolbar = {};

    constructor(
        protected workLogService: WorkLogService,
        protected authenticationService: AuthenticationService
    ) {
        //
    }

    ngOnInit() {
        this.createDatatable();

        this.toolbar = {
            buttons: [],
        };

        this.user = this.authenticationService.user();
    }

    protected createDatatable() {
        this.table = {
            service: this.workLogService,
            callbacks: {
                click: () => {
                },
            },
        };
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/work-logs/pages/work-logs/index/index.component.ts